export { FullWidthImage } from './FullWidthImage'
